import {AxiosResponse} from 'axios';
import {setStatisticAC} from 'pages/beersView/store/beerPreviewSlice';
import {call, put} from 'redux-saga/effects';
import {getBeerSocialMediaStatistic} from 'services/beers';
import {handleError} from 'store/app/error/saga';
import ApiData from 'typescript/interfaces/ApiData';
import {IBeerSocialMediaStatistic} from 'typescript/models/Beer';

import {getBeerSocialMediaStatisticACS} from '../requestAC';

export function* getSocialMediaStatisticSaga(action: ReturnType<typeof getBeerSocialMediaStatisticACS>) {
  try {
    const response: AxiosResponse<ApiData<IBeerSocialMediaStatistic>> = yield call(
      getBeerSocialMediaStatistic,
      action.payload,
    );

    yield put(setStatisticAC(response.data.data));
  } catch (error) {
    yield call(handleError, error, 'Could not get beer social media statistic.');
  }
}
